import { controls, grouped } from "../../controls";
import moment from "moment";

const atm_log_register= {
  label: "atm_log_register",
  starting: true,
  url: "atm_log_register",
  pageLabel: "atm_log_register",
  pageType: "history",
  filter: [

    ...grouped.iterative("advance"),

    //...controls.displayText({ tab: "filter", label: "Account", width: "col-sm-1" }),
   // ...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account Code", name: "account_code", width: "col-sm-2", fastpath: "accounts" }),
   // ...controls.showData({ tab: "filter", displaytype: "capital", data: "account_display", width: "col-sm-2" }),


    // ...controls.displayText({ tab: "filter", label: "Account" }),
    // ...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account_code", name: "account_code", fastpath: "accounts" }),
    // ...controls.showData({ tab: "filter", displaytype: "capital", data: "account_display" }),

  ],
  form: [],


  history: {
    perPage: 10,
    reportHeader: "atm_log_register ",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    textReportProps: {
      'Recon': {
        filename: `basicinfo$pageData.as_on_date$A-01.RC`,
        // fields:['systraceno','cardno','rrn','actype','acno','acname','branchcode','branchname','trntype','cdflag','amount','trndate','trntime','trndate','trntime','terminalid','location','respcode'],
        format: {}
      },
    },
    displayColumns: [
    {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "Record No",
        accessor: "record_no",
        widthRecon: { size: 6 }
      },
      {
        Header: "Date",
        accessor: "value_date",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
       {
        Header: "Process",
        accessor: "processcode",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "SystraceNo",
        accessor: "systraceno",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "OrgSystraceNo",
        accessor: "orgsystraceno",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Terminalid",
        accessor: "terminalid",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Account No",
        accessor: "account_code",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Card No",
        accessor: "cardno",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Location",
        accessor: "location",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Amount",
        accessor: "amount",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Fees",
        accessor: "fees",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "RRN",
        accessor: "rrn",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "InstCode",
        accessor: "instcode",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Reversal",
        accessor: "is_reversal",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "RespCode",
        accessor: "respcode",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      


    ]
  }
};

export default atm_log_register ;